import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import InventoryIcon from "@mui/icons-material/Inventory";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import {
    PACKAGES_ROUTE_MODULE_KEY,
    SOUSCRIPTIONS_ROUTE_MODULE_KEY,
    TRANSACTIONS_ROUTE_MODULE_KEY,
} from "../../constants/routerConstants";

export const routeModules = {
  [PACKAGES_ROUTE_MODULE_KEY]: {
    title: "Packages",
    icon: InventoryIcon,
  },
  [TRANSACTIONS_ROUTE_MODULE_KEY]: {
    title: "Transactions",
    icon: ReceiptLongIcon,
  },
  [SOUSCRIPTIONS_ROUTE_MODULE_KEY]: {
    title: "Mes forfaits",
    icon: AppRegistrationIcon,
  },
};
